import { API_BASE_URL, ACCESS_TOKEN } from "../constants";

const request = (options) => {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  const headers = new Headers({
    "Content-Type": "application/json",
  });

  if (localStorage.getItem(ACCESS_TOKEN)) {
    headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN),
    );
  }

  const defaults = { headers: headers };
  options = Object.assign({}, defaults, options);

  return fetch(options.url, options)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(new Error(response.statusText));
      }
      return response;
    })
    .then((response) => {
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      } else {
        return response.text();
      }
    })
    .catch((err) => {
      console.log(err);
      return Promise.reject(new Error(err));
    });
};

// Separate request function for authentication endpoints
const authRequest = (options) => {
  const headers = new Headers({
    "Content-Type": "application/json",
  });

  const defaults = { headers: headers };
  options = Object.assign({}, defaults, options);

  return fetch(options.url, options)
    .then(async (response) => {
      console.log('Response status:', response.status);
      const contentType = response.headers.get("content-type");
      console.log(contentType);
      
      const body = await response.json();
      console.log("Response body:", body);

      // Return both status and body
      return {
        status: response.status,
        data: body
      };
    })
    .catch((err) => {
      console.error("Auth request error:", err);
      // Ensure we always throw an object with a message
      if (typeof err === 'string') {
        throw { message: err };
      }
      if (!err.message) {
        throw { message: 'An unexpected error occurred' };
      }
      throw err;
    });
};

export function getCurrentUser() {
  return request({
    url: API_BASE_URL + "/api/v1/user/me",
    method: "GET",
  });
}

export function saveAgreement(timeZone) {
  const payload = {
    timeZone: timeZone,
  };

  return request({
    url: API_BASE_URL + "/api/v1/register/agreement",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function wifiAgreement(timeZone) {
  const payload = {
    timeZone: timeZone,
  };

  return request({
    url: API_BASE_URL + "/api/v1/register/wifi-agreement",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function isIspUser() {
  return request({
    url: API_BASE_URL + "/api/v1/register/isIspUser",
    method: "GET",
  });
}

export function savePaymentPlan(product, paymentPlan, isIspUser) {
  const payload = {
    product: product,
    paymentPlan: paymentPlan,
    isIspUser: isIspUser,
  };

  return request({
    url: API_BASE_URL + "/api/v1/payment/plan",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updatePaymentPlan(product, paymentPlan, isIspUser) {
  const payload = {
    product: product,
    paymentPlan: paymentPlan,
    isIspUser: isIspUser,
  };

  return request({
    url: API_BASE_URL + "/api/v1/payment/update-plan",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function blackLight(url) {
  console.log(url);
  return request({
    url: API_BASE_URL + "/api/blacklight/" + url,
    method: "GET",
  });
}

export function webDomainReport() {
  return request({
    url: API_BASE_URL + "/api/blacklight/webdomain-details",
    method: "GET",
  });
}

export function saveSubscription(paymentMethodId, name, promoCode) {
  const payload = {
    paymentMethodId: paymentMethodId,
    name: name,
    promoCode: promoCode,
  };

  return request({
    url: API_BASE_URL + "/api/v1/payment/subscribe",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function validatePromoCode(code) {
  const payload = {
    promoCode: code,
  };

  return request({
    url: API_BASE_URL + "/api/v1/payment/promo",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getDashboard() {
  return request({
    url: API_BASE_URL + "/api/v1/user/dashboard-details",
    method: "GET",
  });
}

export function updateIp() {
  return request({
    url: API_BASE_URL + "/api/v1/register/updateIp",
    method: "POST",
  });
}
export function blockApps(appName, appStatus) {
  const payload = {
    appName: appName,
    appStatus: appStatus,
  };

  return request({
    url: API_BASE_URL + "/api/v1/user/block-apps",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getAppsBlockStatus() {
  return request({
    url: API_BASE_URL + "/api/v1/user/apps-status",
    method: "GET",
  });
}

export function blockWebsites(website, status) {
  const payload = {
    websiteName: website,
    websiteStatus: status,
  };

  return request({
    url: API_BASE_URL + "/api/v1/user/block-website",
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getWebsites() {
  return request({
    url: API_BASE_URL + "/api/v1/user/getWebsites",
    method: "GET",
  });
}

export function getBlockedDomainsCount() {
  return request({
    url: API_BASE_URL + "/api/v1/user/getBlockedDomainsCount",
    method: "GET",
  });
}

export function getDpaData() {
  return request({
    url: API_BASE_URL + "/api/v1/user/dpa-data",
    method: "GET",
  });
}

export function deactivateUser() {
  return request({
    url: API_BASE_URL + "/api/v1/user/deactivate-user",
    method: "GET",
  });
}

export function updateEmailPreferences(preferences) {
  return request({
    url: API_BASE_URL + "/api/v1/user/email-preferences",
    method: "POST",
    body: JSON.stringify(preferences),
  });
}

// API calls for authentication (login & signup)
export function login({ email, password }) {
  return authRequest({
    url: API_BASE_URL + "/api/v1/auth/login",
    method: "POST",
    body: JSON.stringify({ email, password })
  });
}

export function signup({ email, password }) {
  return authRequest({
    url: API_BASE_URL + "/api/v1/auth/signup",
    method: "POST",
    body: JSON.stringify({ email, password })
  });
}
